import styled from 'styled-components';
import { lightGrey3Color } from 'js/config/style';

export default styled.div`
  color: ${lightGrey3Color};
  float: left;
  margin-right: 0.25rem;
`;
